import { Injectable } from '@angular/core';
import { SettingsState, SettingsStore } from './settings.store';
import { SettingsQuery } from './settings.query';

import merge from 'lodash/merge';

@Injectable({ providedIn: 'root' })
export class SettingsService {

  constructor(private store: SettingsStore, private query: SettingsQuery) {
  }

  select(key: keyof SettingsState) {
    return this.query.select(key);
  }

  getValue() {
    return this.query.getValue();
  }

  update(newSettings: Partial<SettingsState>) {
    // Use lodash merge because this state is nested.
    this.store.update(prevSettings => merge({}, prevSettings, newSettings));
  }
}
